export default __webpack_public_path__ + "static/media/singular3.93935b4f.png";